/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/min_over_time.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the minimum value of all points in the specified time range.
 *
 * @example
 * min_over_time(http_requests_total[5m])
 */
const definition: PromqlFunctionDefinition = {
  type: 'within_series',
  name: 'min_over_time',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'range_vector',
          optional: false,
          description: 'Range vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
